module.exports = __webpack_public_path__ + "static/visitor_bg-8c0d86af11e815f4d8c337ee490b1f12.png";